import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useSWRImmutable from 'swr/immutable';
import type { CMSGroupParams } from '@/api/cms/base';
import { fetcherCMS } from '@/modules/api';
import { createCMSQuery, getCMSLocale } from '@/modules/cms';
import { useMatchingSections } from '@/modules/restrictions/hooks/useAccessSections';

export interface IMinDeposit {
  currency: string;
  amount: number;
}

export interface ISpinValue extends IMinDeposit {}

export interface ICMSPromocode extends CMSGroupParams {
  code: string;
  minDep: IMinDeposit[];
  offer: string;
  spinValue?: ISpinValue[];
  groupKey?: string;
}

export const useCMSPromocodes = () => {
  const {
    i18n: { language },
  } = useTranslation();

  const query = useMemo(
    () =>
      createCMSQuery({
        populate: {
          min_dep: '*',
          spin_value: '*',
        },
        ...getCMSLocale(language),
      }),
    [language]
  );

  const {
    data = [],
    error,
    isLoading,
  } = useSWRImmutable<ICMSPromocode[]>(`/promocodes?${query}`, fetcherCMS);

  const arr = useMatchingSections(data || []);

  return {
    data: arr,
    isLoading,
    error,
  };
};
